var StoresListCardView = require('./stores-list-item');
const StoresListItemModel = require("../../models/stores-list/stores-list");
const moment = require("moment");

var StoresListView = Backbone.Epoxy.View.extend({
  template: 'stores-list.storesList',
  bindings: 'data-bind',

  events: {
    'focus #zipInput': function(e) { this.$(e.target).select(); },
  },

  itemView: StoresListCardView,

  initialize: function() {
    this.isLoading = true;
    this.dataVersion = 0;
    this.renderVersion = -1;

    this.model = new StoresListItemModel();
    this.collection = this.model.get('stores');
  },

  refresh: function() {
    this.setData();
  },

  setData: function(params) {
    if (params.store) {
      this.model.set('store', params.store);
    }
  },

  initEventListeners: function() {
    this.model.on('change:zipCode', this.setStoresDataByZip, this);
  },

  removeEventListeners: function() {
    this.model.off('change:zipCode', this.setStoresDataByZip, this);
    document.getElementById("backToSearch").removeEventListener('click', this.focusSearch);
    document.getElementById("clickToSearch").removeEventListener('click', this.focusSearch);
  },

  beforeRender: function() {
    if (this.isLoading) {
      bookedby.app.startLoading();
      this.$el.html('');
      return false;
    }

    this.initEventListeners();

    return true;
  },

  afterRender: function() {
    if (!this.isLoading) {
      bookedby.app.finishLoading();
    }

    this.applyBindings();
    this.goUserPosition();
    // events prop doesn't work on android with enabled talk back
    document.getElementById("backToSearch").addEventListener('click', this.focusSearch);
    document.getElementById("clickToSearch").addEventListener('click', this.focusSearch);
  },

  cleanup: function() {
    this.model.set('zipCode', '');

    this.removeBindings();
    this.removeEventListeners();
  },

  hasChanges: function() {
    return false;
  },

  focusSearch: function() {
    $('#zipInput').focus().select();
  },

  goUserPosition: function() {
    const store = this.model.get('store');

    if (navigator.geolocation && !store) {
      navigator.geolocation.getCurrentPosition(_.bind(function(position) {
        this.setStoresDataByCoords(position.coords.latitude, position.coords.longitude);
      }, this), _.bind(function(error) {
        console.log(error);
        this.setStoresDataByZip();
      }, this));
    } else {
      this.setStoresDataByZip();
    }
  },

  setStoresDataByCoords: function(latitude, longitude) {
    this.isLoading = true;

    $.ajax({
      url: bookedby.routes.SEARCH.SEARCH_NEAREST_OPEN_STORES,
      contentType: 'application/json',
      data: {
        storeGroupUuid: bookedby.staticData.storeGroupId,
        latitude: latitude,
        longitude: longitude,
        radius: 32 * 1000, // 20 miles
        date: moment().format('YYYY-MM-DD')
      },
      method: 'GET',
      cache: false,
      success: _.bind(function(data) {
        if (data.success) {
          this.model.bindModel({
            ...data,
            stores: data.stores.map(function(it) {
              return {
                id: it.id,
                name: it.name,
                address1: it.addressLine1,
                address2: it.addressLine2,
                phone: it.phone,
              }
            })
          });
        }
      }, this)
    });

    this.isLoading = false;
  },

  setStoresDataByZip: function() {
    this.isLoading = true;

    $.ajax({
      url: bookedby.routes.STORES.FIND_BY_ZIP,
      contentType: 'application/json',
      data: {
        storeGroupUuid: window.bookedby.staticData.storeGroupId,
        zipCode: this.model.get('zipCode'),
        store: this.model.get('store'),
      },
      method: 'GET',
      cache: false,
      success: _.bind(function(data) {
        if (data.success) {
          this.model.bindModel(data);
        }
      }, this)
    });

    this.isLoading = false;
  }

});

module.exports = StoresListView;
